import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
const HOURS = Array.from({ length: 24 }, (_, h) => h);
const MONTH_DAYS = Array.from({ length: 28 }, (_, d) => d + 1);
const hourLabel = (h) => `${String(h).padStart(2, "0")}:00`;
const ordinal = (n) => `${n}${n % 10 === 1 && n !== 11 ? "st" : n % 10 === 2 && n !== 12 ? "nd" : n % 10 === 3 && n !== 13 ? "rd" : "th"}`;

const Pick = ({ id, label, value, options, render, onChange }) => (
  <div className="space-y-2">
    <Label>{label}</Label>
    <Select value={String(value)} onValueChange={(v) => onChange(Number(v))}>
      <SelectTrigger data-testid={id} className="w-full sm:w-48"><SelectValue /></SelectTrigger>
      <SelectContent>{options.map((o) => <SelectItem key={o} value={String(o)}>{render(o)}</SelectItem>)}</SelectContent>
    </Select>
  </div>
);

export const ScheduleSettings = ({ schedule, onChange }) => (
  <div className="grid gap-4 lg:grid-cols-2" data-testid="schedule-settings">
    <Card className="p-5">
      <h3 className="font-heading text-lg font-bold">Weekly reminder</h3>
      <p className="mt-1 text-sm text-muted-foreground">Goes to contractors who haven't submitted the most recent week (ending Friday).</p>
      <div className="mt-4 flex flex-wrap gap-4">
        <Pick id="schedule-reminder-day" label="Day" value={schedule.reminder_day} options={DAYS.map((_, i) => i)} render={(i) => DAYS[i]} onChange={(v) => onChange({ reminder_day: v })} />
        <Pick id="schedule-reminder-hour" label="Time (UK)" value={schedule.reminder_hour} options={HOURS} render={hourLabel} onChange={(v) => onChange({ reminder_hour: v })} />
      </div>
    </Card>
    <Card className="p-5">
      <h3 className="font-heading text-lg font-bold">Month-end Accounts email</h3>
      <p className="mt-1 text-sm text-muted-foreground">Sends the previous month's full day-by-day record.</p>
      <div className="mt-4 flex flex-wrap gap-4">
        <Pick id="schedule-monthly-day" label="Day of month" value={schedule.monthly_day} options={MONTH_DAYS} render={ordinal} onChange={(v) => onChange({ monthly_day: v })} />
        <Pick id="schedule-monthly-hour" label="Time (UK)" value={schedule.monthly_hour} options={HOURS} render={hourLabel} onChange={(v) => onChange({ monthly_hour: v })} />
      </div>
    </Card>
  </div>
);
